// Hook per articoli di aiuto contestuali in base alla pagina corrente
import { useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'

// Mapping percorso → slug articoli correlati
const PAGE_HELP_MAPPING: Record<string, string[]> = {
  '/tickets/new': ['creare-un-nuovo-ticket', 'gestire-le-priorita'],
  '/tickets': ['gestire-i-ticket', 'filtri-avanzati'],
  '/reports': ['visualizzare-rapportini', 'scaricare-pdf'],
  '/reports/new': ['come-compilare-un-rapportino', 'compilare-offline'],
  '/warehouse': ['visualizzare-stock', 'scanner-barcode'],
  '/warehouse/materials': ['anagrafica-materiali'],
  '/warehouse/movements': ['registrare-movimenti'],
  '/hse': ['gestire-documenti-sicurezza', 'verificare-abilitazioni'],
  '/hse/documents': ['gestire-documenti-sicurezza'],
  '/hse/certifications': ['verificare-abilitazioni', 'scadenzario'],
  '/analytics': ['panoramica-analytics', 'esportare-dati'],
  '/settings': ['impostazioni-profilo', 'configurare-2fa'],
  '/settings/security': ['configurare-2fa'],
  '/gamification': ['sistema-punti', 'leaderboard'],
  '/integrations': ['configurare-integrazioni'],
  '/dashboard': ['panoramica-dashboard', 'kpi-principali'],
}

export interface HelpArticle {
  id: string
  slug: string
  title: string
  excerpt: string
  category: string
}

export function useHelp() {
  const { pathname } = useLocation()

  // Trova la chiave di mapping più specifica
  const matchedKey = Object.keys(PAGE_HELP_MAPPING)
    .filter((key) => pathname.startsWith(key))
    .sort((a, b) => b.length - a.length)[0]

  const slugs = matchedKey ? PAGE_HELP_MAPPING[matchedKey] : []

  const query = useQuery({
    queryKey: ['help', 'contextual', pathname],
    queryFn: async () => {
      // Usa l'endpoint reale del backend: GET /api/help/contextual/:page
      // Il path va URL-encoded escludendo lo slash iniziale
      const encodedPage = encodeURIComponent(pathname)
      const response = await api.get<{ path: string; articles: HelpArticle[] }>(
        `/help/contextual/${encodedPage}`
      )
      // Risposta: { path, articles } — estraiamo articles con fallback
      const payload = response.data
      return Array.isArray(payload?.articles) ? payload.articles : []
    },
    enabled: slugs.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minuti
  })

  return {
    articles: query.data ?? [],
    isLoading: query.isLoading,
    hasHelp: slugs.length > 0,
    currentPageSlugs: slugs,
  }
}
